import { TourUrlHandlerConfig } from "@shared/types/localTypes/tour.ts";
import { sleep } from "@shared/utils/tools.ts";

import json from "../../json/logStreamer.json";

export default async (config?: TourUrlHandlerConfig) => {
  if (config?.method === "DELETE") {
    await sleep(350);
    return {};
  }
  return JSON.parse(JSON.stringify(await json));
};
